import { fetchAuthSession } from "aws-amplify/auth";
import { fetchAPI } from './api';

const API_URL = process.env.REACT_APP_LEMONSQUEEZY_API_URL;

interface FetchOptions {
  method?: 'GET' | 'POST' | 'PUT' | 'DELETE';
  body?: BodyInit | null;
  headers?: HeadersInit;
}

export async function fetchLemonSqueezyAPI(endpoint: string, options: FetchOptions = {}) {
    const session = await fetchAuthSession();
    if (!session || !session.tokens) {
        return fetchLemonSqueezyAPIInternal(endpoint, options);
    }
    const token = session.tokens.accessToken.toString();
    return fetchLemonSqueezyAPIInternal(endpoint, options, token);
}

export function fetchLemonSqueezyAPIInternal(endpoint: string, options: FetchOptions = {}, token?: string) {
  const url = `${API_URL}${endpoint}`;

  // Initialize headers if not already present
  if (!options.headers) {
    options.headers = {};
  }

  // Set default headers and merge with any existing ones
  const defaultHeaders: HeadersInit = {
    'Content-Type': 'application/json',
  };

  // Add the Authorization header if a token is provided
  if (token) {
    defaultHeaders['Authorization'] = `Bearer ${token}`;
  }

  // Merge headers, overwriting defaults with any specified in options.headers
  options.headers = { ...defaultHeaders, ...options.headers };

  // Use fetch to make the HTTP request
  return fetch(url, options)
    .then(response => {
      // Check if the HTTP response is not OK to throw an error
      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }
      return response.json(); // Assuming server responses are always JSON
    })
    .catch(error => {
      // Log and re-throw the error for further handling
      console.error('Fetch error:', error);
      throw error;
    });
}

export interface CheckoutSuccessResponse {
  message: string;
  user_id: string;
}

export async function activateSubscription(sessionId: string): Promise<CheckoutSuccessResponse> {
  return fetchLemonSqueezyAPI('/checkout_success', {
    method: 'POST',
    body: JSON.stringify({ session_id: sessionId })
  });
}

export async function getCustomerPortalUrl(): Promise<string> {
    try {
        const response = await fetchLemonSqueezyAPI('/manage', { method: 'GET' });
        return response.customer_portal_url;
    } catch (error) {
        console.error('Error getting customer portal URL:', error);
        throw error;
    }
}
